import { configureStore } from "@reduxjs/toolkit";
import sendLinkSlice from "./features/sendLinkSlice";

const store  =configureStore({
    reducer:{
        sendKyc: sendLinkSlice
    }
})

export default store;